module.exports = __webpack_public_path__ + "img/web2.ef9871da.png";